const {links} = require('../common');
const css = require('./desktop.scss');
const {domains} = require('../../data/constants.json');

module.exports = ({mainLinks, socialLinks, t}) => `
  <div class="${css.contentWrapper}">
    ${links(mainLinks, {
      list: css.menu,
      item: css.menuColumn,
      itemContent: css.menuHeading
    }, {
      list: css.menuList,
      item: css.menuItem
    })}

    <div class="${css.aside}">
      <a href="//${domains.wix}/" class="${css.asideLogo}" title="${t('title_wix_logo')}">Wix.com</a>
      <p class="${css.asideParagraph}">${t('description')}</p>
      <p class="${css.asideParagraph}">${t('closing_line1')} ${t('closing_line2')}</p>
      <p class="${css.asideParagraph}">${t('closing_years')}</p>
      ${links(socialLinks, {
        list: css.social,
        item: css.socialItem
      })}
    </div>
  </div>
`;



// WEBPACK FOOTER //
// ./templates/footer/desktop.js